import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
    {
    question: 'What types of content do you provide?',
    answer: 'We offer website content, blog articles, SEO content, product descriptions, email copy, social media captions, and press releases.',
  },
  {
    question: 'Is your content SEO-optimized?',
    answer: 'Yes. All our content is optimized with targeted keywords, proper structure, and meta elements to enhance search visibility.',
  },
  {
    question: 'Can you write for specific industries?',
    answer: 'Definitely. Our writers specialize in various sectors including healthcare, tech, real estate, education, automotive, and more.',
  },
  {
    question: 'Do you offer content rewriting or editing services?',
    answer: 'Yes, we can refine and optimize your existing content to align with SEO and brand tone.',
  },
  {
    question: 'How long does it take to deliver content?',
    answer: 'Turnaround depends on content type and volume. For standard website pages or blogs, we typically deliver within 2–4 business days.',
  },
  {
    question: 'Is your content original and plagiarism-free?',
    answer: 'Absolutely. All content is 100% unique, checked with plagiarism tools, and tailored specifically for your brand and audience.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p>Find quick answers to common questions about our Content Writing Services. Whether you’re curious about process, pricing, or delivery, this section helps you understand how we create high-quality, SEO-optimized content tailored to your brand’s needs.
</p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
